module.exports = __webpack_public_path__ + "img/pardinho.95ba55dc.png";